import { Card } from '@/components/Bicester';
import { FieldArray } from 'formik';
import React from 'react';
import ServiceInfo from '../../components/ServiceInfo';
import { fetchAddEditExpress, fetchExpressInfo } from '@/services/site/express';
import { defaultExpressInfo, expressSchema } from '../../Express/constants';
import { IconButton } from 'rsuite5';
import Image from '@/components/Bicester/Image';

const ExpressInfo = () => {
  return (
    <ServiceInfo
      defaultServiceInfo={defaultExpressInfo}
      serviceSchema={expressSchema}
      fetchInfo={fetchExpressInfo}
      fetchEdit={fetchAddEditExpress}
      getDefaultInfo={(data) => {
        return {
          remark: data?.remark,
          courier_company: data?.courier_company,
          money: data?.money,
          num: data?.num,
          is_not_pay: data?.is_not_pay,
          expressage_items: data?.expressage_items,
        };
      }}
      getSubmitData={(id, values) =>
        Object.assign({}, values, {
          expressage_items: JSON.stringify(values?.expressage_items),
          id,
        })
      }
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Input required isEdit={isEdit} label="快递公司" formKey="courier_company" />
          <Card.Input required isEdit={isEdit} label="包裹数量" inputType="number" formKey="num" />
          <Card.Picker isEdit={isEdit} label="是否到付" formKey="is_not_pay" pickerType="TorF" />
          <Card.Input required isEdit={isEdit} label="收费金额" inputType="price" formKey="money" />
          <FieldArray name="expressage_items">
            {({ insert, remove, push }) => (
              <>
                {formik.values.expressage_items.length > 0 &&
                  formik.values.expressage_items.map((item, index) => (
                    <div key={index}>
                      <Card.Input
                        required
                        isEdit={isEdit}
                        label="快递单号"
                        formKey={`expressage_items.${index}.expressage_no`}
                        hasBtn={isEdit && formik.values.expressage_items.length > 1}
                        customBtn={
                          <IconButton
                            className={`w-[17px] h-[17px] ml-[5px] ${
                              index === 0 && formik.values.expressage_items.length <= 1
                                ? 'invisible'
                                : ''
                            }`}
                            onClick={() => remove(index)}
                          >
                            <Image src="/resources/images/delete.svg" />
                          </IconButton>
                        }
                      />
                    </div>
                  ))}
                {isEdit && (
                  <div className="flex">
                    <div className="flex-[3]"></div>
                    <div className="flex-[5]">
                      <IconButton
                        className="flex items-center"
                        onClick={() => push({ expressage_no: '' })}
                      >
                        <Image src="/resources/images/add.svg" />
                        <div className="text-[12px] text-[#999999] ml-[5px]">新增</div>
                      </IconButton>
                    </div>
                  </div>
                )}
              </>
            )}
          </FieldArray>
          <Card.Input
            isEdit={isEdit}
            label="备注"
            placeholder="如有保价，备注保价金额"
            formKey="remark"
            inputType="textarea"
          />
        </>
      )}
    />
  );
};

export default ExpressInfo;
